{
  "name": "warp-nebula",
  "doc": "Almost no zoom, a strong noise warp: the history is kneaded by a slowly moving field and forms clouds. The DOTS wave seeds it with bright grains.",
  "cx": 0.5,
  "cy": 0.5,
  "zoom": 1.003,
  "zoomexp": 1.0,
  "rot": 0.001,
  "rotr": 0.0,
  "dx": 0,
  "dy": 0,
  "sx": 1,
  "sy": 1,
  "warp": 0.014,
  "warpScale": 3.5,
  "warpSpeed": 0.35,
  "decay": 0.962,
  "invert": 0,
  "hueShift": 0.005,
  "darkenCenter": 0.0,
  "wave": "DOTS",
  "waveColor": 1,
  "shapes": 1,
  "energy": [
    0.25,
    0.7
  ]
}